const POSITION_GROUPS = [
  {
    "label": "พนักงานจ้างตามภารกิจ (คุณวุฒิ)",
    "empType": "ตามภารกิจ",
    "positions": [
      "ผู้ช่วยนักจัดการงานทั่วไป",
      "ผู้ช่วยนักพัฒนาการท่องเที่ยว",
      "ผู้ช่วยนักวิชาการคอมพิวเตอร์",
      "ผู้ช่วยนิติกร",
      "ผู้ช่วยเจ้าพนักงานธุรการ",
      "ผู้ช่วยเจ้าพนักงานทะเบียน",
      "ผู้ช่วยเจ้าพนักงานป้องกันฯ",
      "ผู้ช่วยนักวิชาการเงินและบัญชี",
      "ผู้ช่วยเจ้าพนักงานการเงินและบัญชี",
      "ผู้ช่วยเจ้าพนักงานจัดเก็บรายได้",
      "ผู้ช่วยนักวิชาการคลัง",
      "ผู้ช่วยเจ้าพนักงานการคลัง",
      "ผู้ช่วยเจ้าพนักงานพัสดุ",
      "ผู้ช่วยวิศวกรโยธา",
      "ผู้ช่วยสถาปนิก",
      "ผู้ช่วยนายช่างโยธา",
      "ผู้ช่วยนายช่างเขียนแบบ",
      "ผู้ช่วยนายช่างไฟฟ้า",
      "ผู้ช่วยนายช่างศิลป์",
      "ผู้ช่วยนายช่างเครื่องกล",
      "ผู้ช่วยนักวิชาการสาธารณสุข",
      "ผู้ช่วยนักวิชาการสุขาภิบาล",
      "ผู้ช่วยสัตวแพทย์",
      "ผู้ช่วยเจ้าพนักงานสัตวบาล",
      "ผู้ช่วยนักวิเคราะห์นโยบายและแผน",
      "ผู้ช่วยนักประชาสัมพันธ์",
      "ผู้ช่วยเจ้าพนักงานประชาสัมพันธ์",
      "ผู้ช่วยนักวิชาการศึกษา",
      "ผู้ช่วยนักสันทนาการ",
      "ผู้ช่วยนักวิชาการวัฒนธรรม",
      "ผู้ช่วยนักพัฒนาชุมชน",
      "ผู้ช่วยนักทรัพยากรบุคคล",
      "ผู้ช่วยนักจัดการงานเทศกิจ",
      "ผู้ช่วยเจ้าพนักงานเทศกิจ", 
      "ผู้ช่วยนักวิชาการตรวจสอบภายใน"
    ]
  },
  {
    "label": "พนักงานจ้างตามภารกิจ (ทักษะ)",
    "empType": "ตามภารกิจ",
    "positions": [
      "พนักงานขับเครื่องจักรกลขนาดหนัก",
      "พนักงานขับเครื่องจักรกลขนาดเบา",
      "พนักงานขับรถยนต์",
      "พนักงานดับเพลิง",
      "พนักงานวิทยุ",
      "พนักงานเทศกิจ",
      "ช่างไฟฟ้า",
      "เจ้าหน้าที่ตกแต่งสถานที่",
      "พนักงานช่วยเหลือสัตวแพทย์",
      "พนักงานดูแลประจำสระว่ายน้ำ",
      "คนสวน "
    ]
  },
  {
    "label": "พนักงานจ้างทั่วไป",
    "empType": "ทั่วไป",
    "positions": [
      "คนงาน",
      "คนสวน",
      "คนครัว",
      "นักการ",
      "ภารโรง",
      "คนงานประจำรถขยะ",
      "พนักงานวิทยุ",
      "พนักงานดับเพลิง"

    ]
  },
  {
    "label": "พนักงานจ้างผู้เชี่ยวชาญพิเศษ",
    "empType": "ผู้เชี่ยวชาญพิเศษ",
    "positions": [
    "ด้านสาธารณสุข",
    "ด้านการวางแผนพัฒนาคุณภาพชีวิตทุกช่วงวัยและส่งเสริมการมีส่วนร่วม",
    "ด้านการวางแผนพัฒนาโครงสร้างพื้นฐาน"

    ]
  }
]
module.exports = { POSITION_GROUPS }
